import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

/* eslint-disable */
var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import Button from '../Button';
import classnames from 'classnames';

var RadioButton = function RadioButton(props) {
  var checked = props.checked,
      value = props.value,
      className = props.className,
      restProps = __rest(props, ["checked", "value", "className"]);

  var type = checked ? 'normal' : 'hollow';
  var clx = checked ? classnames('roo-btn-radio-active', className) : className;
  return /*#__PURE__*/React.createElement(Button, _Object$assign({}, restProps, {
    className: clx,
    type: type
  }));
};

RadioButton.displayName = 'RRadioButton';
RadioButton.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  className: PropTypes.string
};
RadioButton.defaultProps = {
  disabled: false,
  checked: false,
  className: ''
};
export default RadioButton;